import { Amplify } from "aws-amplify";
import { generateClient } from "aws-amplify/api";
import { v4 as uuidv4 } from "uuid";
import config from "../amplifyconfiguration.json";
import { getRawToken } from "../utils/tokenFunctions";
import {
  createChatAgentSession,
  createControlError,
  createCreditos,
  createLog,
  createPerfil,
  createProjectUserInput,
  createProyecto,
  createResultado,
  updateCreditos,
  updatePerfil,
  updateProyecto,
  updateResultado,
} from "../graphql/mutations";
import {
  creditosByUsuarioId,
  getProyecto,
  getResultado,
  getUsuario,
  listWhitelistUsers,
  logsByUsuarioId,
  perfilsByUsuarioId,
  resultadosByProyectoId,
  usuariosByEmail,
} from "../graphql/queries";
import {
  getProyectosByOrganizacion,
  proyectosByUsuarioIdCustom,
} from "../graphql/utils/extends";
import { iUserProfile } from "../interfaces/Auth/iUserProfile";
import { iDataCreditosDynamoDB } from "../interfaces/iDataCreditosDynamoDB";
import {
  iDataProyectoDynamoDB,
  iDataProyectoDynamoDBOrganizacion,
  iDataResultadoDynamoDB,
} from "../interfaces/iDataProyectoDynamoDB";
import { iDataResultadoDB } from "../interfaces/iDataResultadoDB";
import { iDataResultadoLLMABP } from "../interfaces/iDataResultadoLLMABP";
import { iDataResultadoLLMAulaActiva } from "../interfaces/iDataResultadoLLMAulaActiva";
import { iDataUserLogs } from "../interfaces/iDataUserLogs";
import { DynamoUser } from "../interfaces/SuperAdmin/Others/DynamoUser";
import { ClientInfo } from "../utils/getClientInfo";
import { getOrCreateSessionId } from "../utils/error/session";

Amplify.configure(config);

// Función para ejecutar GraphQL con autenticación híbrida (LTI/Cognito)
const executeGraphQLQuery = async (queryConfig: any) => {
  const rawToken = getRawToken();
  
  if (rawToken) {
    // Modo LTI: hacer HTTP request directo al endpoint GraphQL
    const graphqlEndpoint = config.aws_appsync_graphqlEndpoint;
    
    const response = await fetch(graphqlEndpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': rawToken, // Sin "Bearer " prefix, usar token directo
        'x-api-key': '', // Incluir API key si existe
      },
      body: JSON.stringify({
        query: queryConfig.query,
        variables: queryConfig.variables,
        operationName: queryConfig.operationName,
      }),
    });

    if (!response.ok) {
      const errorText = await response.text();
      console.error('GraphQL HTTP Error:', response.status, errorText);
      throw new Error(`HTTP error! status: ${response.status}, body: ${errorText}`);
    }

    const result = await response.json();
    
    if (result.errors) {
      console.error('GraphQL Errors:', result.errors);
      throw new Error(`GraphQL Error: ${result.errors.map((e: any) => e.message).join(', ')}`);
    }

    return result;
  } else {
    // Modo COGNITO: usar configuración por defecto de Amplify
    const client = generateClient();
    return await client.graphql(queryConfig);
  }
};

const client = generateClient();

/**
 *
 * @param email
 * @param name
 * @returns
 */
// export const CreateUser = async (email:string, name:string) => {
//     console.log("CreateUser", email, name);
//     try {
//         const result = await client.graphql({
//             query: createUsuario,
//             variables: {
//                 input: {
//                     name: name,
//                     email: email
//                 },
//                 condition: {
//                     email: { ne: email } // Verifica que no exista ningún usuario con el mismo cognitoUserId
//                 }
//             }
//         });
//         console.log("CreateUser", { result });
//         return result;

//     } catch (error) {
//         console.error("error en la mutacion CreateUser", error);
//     }
// }

/**
 *
 * @param {*} userId
 * @param {*} proyectoId
 */

/**
 *
 * @param {*} userId
 * @param {*} proyectName
 * @returns
 */
export const CreateProyect = async (
  userId: string,
  id_organizacion: string | null,
  proyectoId: string,
  proyectName: string,
  tipoEstructura: string,
  nivelCurso: string,
  asignaturas: string[]
): Promise<iDataProyectoDynamoDB> => {
  try {
    const result: any = await client.graphql({
      query: createProyecto,
      variables: {
        input: {
          id: proyectoId,
          name: proyectName,
          usuarioId: userId,
          organizacionId: id_organizacion,
          tipoEstructura,
          nivelCurso,
          asignaturas,
        },
      },
    });
    console.log("CreateProyect", { result });
    return result.data.createProyecto;
  } catch (error: any) {
    console.error("error en la mutacion CreateProyect", error);
    throw new Error("error en la mutacion CreateProyect" + error);
  }
};
/**
 *
 * @param {*} userId
 * @param {*} proyectName
 * @returns
 */
export const CloneProyect = async (
  userId: string,
  id_organizacion: string,
  proyectoId: string,
  proyectName: string,
  tipoEstructura: string,
  nivelCurso: string,
  asignaturas: string[]
): Promise<iDataProyectoDynamoDB> => {
  try {
    const result: any = await client.graphql({
      query: createProyecto,
      variables: {
        input: {
          id: uuidv4(),
          idProyectoFuente: proyectoId,
          isCloneProject: true,
          name: proyectName,
          usuarioId: userId,
          organizacionId: id_organizacion,
          tipoEstructura,
          nivelCurso,
          asignaturas,
        },
      },
    });
    console.log("CloneProyect", { result });
    return result.data.createProyecto;
  } catch (error: any) {
    console.error("error en la mutacion CloneProyect", error);
    throw new Error("error en la mutacion CloneProyect" + error);
  }
};

/**
 *
 * @param proyectoId
 * @param etapa
 * @param resultado
 * @returns
 */
export const CreateResult = async (
  proyectoId: string,
  etapa: number,
  resultado: any,
  promptLLM: string
): Promise<iDataResultadoDB> => {
  try {
    console.log("proyectoId", proyectoId);
    const result: any = await client.graphql({
      query: createResultado,
      variables: {
        input: {
          proyectoId,
          etapa: Number(etapa),
          resultado: JSON.stringify(resultado),
          promptLLM,
        },
      },
    });

    console.log("CreateResult", { result });
    return result.data.createResultado;
  } catch (error: any) {
    console.error("error en la mutacion CreateResult", error);
    throw new Error("error en la mutacion CreateResult" + error);
  }
};

/**
 *
 * @param {*} userId
 * @returns
 */
// export const GetUserByCognitoUserId = async (userId) => {
//     try {
//         const user = await client.graphql({
//             query: getUserByCognitoUserId,
//             variables: {
//                 cognitoUserId: userId
//             }
//         })
//         return user;
//     } catch (error) {
//         console.error("error en la query GetUserByCognitoUserId", error);
//     }
// }

/**
 *
 * @param usuarioId
 * @returns
 */
export const GetProyectosByUserId = async (
  usuarioId: string
): Promise<iDataProyectoDynamoDB[] | null> => {
  try {
    let allItems: iDataProyectoDynamoDB[] = [];
    let nextToken: string | null = null;

    do {
      const result: any = await client.graphql({
        query: proyectosByUsuarioIdCustom,
        variables: {
          usuarioId,
          nextToken, // Si no es la primera iteración, usamos el nextToken para la siguiente página
        },
      });

       // Filtrar los proyectos eliminados antes de acumular
      const items: iDataProyectoDynamoDB[] = result.data.proyectosByUsuarioId.items.filter(
        (p: iDataProyectoDynamoDB) => p.isEliminated !== true
      );

      allItems = allItems.concat(items);

      // Actualizar nextToken para seguir iterando si es necesario
      nextToken = result.data.proyectosByUsuarioId.nextToken;
    } while (nextToken); // Continuar mientras exista un nextToken

    console.log("GetProyectosByUserId", allItems);
    return allItems;
  } catch (error) {
    console.error("error en la query GetProyectosByUserId", error);
    return null;
  }
};

export const GetProyectosByOrganizationId = async (
  organizacionId: string
): Promise<iDataProyectoDynamoDBOrganizacion[] | null> => {
  try {
    let allItems: iDataProyectoDynamoDBOrganizacion[] = [];
    let nextToken: string | null = null;

    do {
      const result: any = await client.graphql({
        query: getProyectosByOrganizacion,
        variables: {
          organizacionId,
          nextToken, // Si no es la primera iteración, usamos el nextToken para la siguiente página
        },
      });

      
       const items: iDataProyectoDynamoDBOrganizacion[] = result.data.proyectosByOrganizacionId.items.filter(
        (p: iDataProyectoDynamoDB) => p.isEliminated !== true
      );

      allItems = allItems.concat(items);

      // Actualizar nextToken para seguir iterando si es necesario
      nextToken = result.data.proyectosByOrganizacionId.nextToken;
    } while (nextToken); // Continuar mientras exista un nextToken

    console.log("GetProyectosByOrganizationId", allItems);
    return allItems;
  } catch (error) {
    console.error("error en la query GetProyectosByOrganizationId", error);
    return null;
  }
};

/**
 *
 * @param {*} email
 * @returns
 */
export const GetUserByEmail = async (email: string): Promise<DynamoUser> => {
  try {
    const result: any = await executeGraphQLQuery({
      query: usuariosByEmail,
      variables: {
        email,
      },
    });
    return Object.assign(result.data.usuariosByEmail.items[0]);
  } catch (error: any) {
    throw new Error("error en la query GetUserByEmail" + error);
  }
};

/**
 *
 * @param {*} userId
 * @returns
 */
export const GetUserById = async (
  userId: string
): Promise<DynamoUser | undefined> => {
  try {
    const result: any = await client.graphql({
      query: getUsuario,
      variables: {
        id: userId,
      },
    });
    console.log("GetUserById", { result });
    return Object.assign(result.data.getUsuario);
  } catch (error) {
    console.error("error en la query GetUserById", error);
  }
};

/**
 *
 * @param usuarioId
 * @returns
 */
export const GetUserProfileByUserId = async (
  usuarioId: string
): Promise<iUserProfile | null> => {
  try {
    const response: any = await client.graphql({
      query: perfilsByUsuarioId,
      variables: {
        usuarioId,
      },
    });
    console.log("GetUserProfileByUserId", { response });
    return Object.assign(response.data.perfilsByUsuarioId.items[0]);
  } catch (error) {
    console.log("El usuario no tiene registro de perfil", error);
    return null;
  }
};

/**
 *
 * @param resultadoId
 * @param nuevoResultado
 * @returns
 */
export const PutProyectoResultadoById = async (
  resultadoId: string,
  nuevoResultado: iDataResultadoLLMAulaActiva | iDataResultadoLLMABP
): Promise<iDataResultadoDB> => {
  console.log(
    `PutProyectoResultadoById resultadoId=${resultadoId} proyectoObj=${nuevoResultado}`
  );
  console.log("nuevoResultado", nuevoResultado);
  try {
    const result: any = await client.graphql({
      query: updateResultado,
      variables: {
        input: {
          id: resultadoId,
          resultado: JSON.stringify(nuevoResultado),
        },
      },
    });
    console.log("PutProyectoResultadoById", { result });
    return result.data.updateResultado;
  } catch (error: any) {
    console.error("error en la query PutProyectoResultadoById", error);
    throw new Error("error en la query PutProyectoResultadoById" + error);
  }
};

/**
 *
 * @param {*} proyectoId
 * @returns
 */
export const GetProyectoById = async (proyectoId: string) => {
  console.log(proyectoId);
  if (!proyectoId) {
    console.error("Error: proyectoId es null o undefined");
    return null;
  }
  try {
    const result: any = await client.graphql({
      query: getProyecto,
      variables: {
        id: proyectoId,
        limit: 1,
      },
    });

    console.log("GetProyectoById", { result });
    return result.data.getProyecto;
  } catch (error) {
    console.error("error en la query GetProyectoById", error);
  }
};

/**
 *
 * @param {*} resultadoId
 * @returns
 */
export const GetResultadoById = async (
  resultadoId: string
): Promise<iDataResultadoDB> => {
  try {
    const result: any = await client.graphql({
      query: getResultado,
      variables: {
        id: resultadoId,
      },
    });

    console.log("GetResultadoById", { result });
    return result.data.getResultado;
  } catch (error: any) {
    console.error("error en la query GetResultadoById", error);
    throw new Error("error en la query GetResultadoById" + error);
  }
};

/**
 *
 * @param proyectoId
 * @returns
 */
export const GetResultadoByProyectoId = async (
  proyectoId: string
): Promise<iDataResultadoDynamoDB> => {
  try {
    const result: any = await client.graphql({
      query: resultadosByProyectoId,
      variables: {
        proyectoId,
      },
    });

    console.log("GetResultadoByProyectoId", { result });
    return result.data.resultadosByProyectoId;
  } catch (error: any) {
    console.error("error en la query GetResultadoByProyectoId", error);
    throw new Error("error en la query GetResultadoByProyectoId" + error);
  }
};

/**
 *
 * @param {*} userId
 * @param {*} event
 * @param {*} detail
 * @returns
 */
export const PostLogRegisterActivityByUserId = async (
  userId: string,
  event: string,
  detail: string
) => {
  try {
    const input = {
      usuarioId: userId,
      action: event,
      ...(detail && { detail }), // Usando un operador spread condicional para agregar detail solo si existe
    };

    console.log(
      `PostLogRegisterActivityByUserId userId=${userId} event=${event}`
    );
    const result = await client.graphql({
      query: createLog,
      variables: {
        input,
      },
    });

    console.log("PostLogRegisterActivityByUserId", { result });
    return result;
  } catch (error) {
    console.error(
      "error en la mutación PostLogRegisterActivityByUserId",
      error
    );
  }
};

/**
 *
 * @param {*} userId
 * @param {*} inTokens
 * @param {*} outTokens
 * @param {*} costo
 * @returns
 */
export const PostRegistroCreditosByUserId = async (
  userId: string,
  inTokens: number,
  outTokens: number,
  costo: number
) => {
  try {
    console.log(
      `PostRegistroCreditosByUserId userId=${userId} inTokens=${inTokens}, outTokens=${outTokens}, costo=${costo}`
    );
    const result = await client.graphql({
      query: createCreditos,
      variables: {
        input: {
          usuarioId: userId,
          creditosUsados: costo,
          tokensIngresados: inTokens,
          tokensRecibidos: outTokens,
        },
      },
    });

    console.log("PostRegistroCreditosByUserId:", { result });
    return result;
  } catch (error) {
    console.error("error en la mutación PostRegistroCreditosByUserId", error);
  }
};

/**
 *
 * @param {*} userId
 * @returns
 */
export const GetRegistroCreditosByUserId = async (
  userId: string
): Promise<iDataCreditosDynamoDB | null> => {
  try {
    console.log(`GetRegistroCreditosByUserId userId=${userId}`);

    // Realizamos la consulta GraphQL
    const result: any = await client.graphql({
      query: creditosByUsuarioId,
      variables: { usuarioId: userId },
    });

    // Extraemos los elementos obtenidos
    const items = result?.data?.creditosByUsuarioId?.items ?? [];

    console.log("GetRegistroCreditosByUserId:", { items });

    // Retornamos el primer ítem si hay resultados, si no, null
    return items.length > 0 ? items[0] : null;
  } catch (error: any) {
    console.error("Error en la query GetRegistroCreditosByUserId", error);

    // Propagamos el error como una excepción, pero sin concatenar el mensaje directamente
    throw new Error(
      `Error en la query GetRegistroCreditosByUserId: ${error.message}`
    );
  }
};

/**
 *
 * @param id
 * @param inTokens
 * @param outTokens
 * @param costo
 * @returns
 */
export const PutRegistroCreditosByUserId = async (
  id: string,
  inTokens: number,
  outTokens: number,
  costo: number
): Promise<iDataCreditosDynamoDB> => {
  try {
    console.log(
      `PutRegistroCreditosByUserId inTokens=${inTokens}, outTokens=${outTokens}, costo=${costo}`
    );
    const result: any = await client.graphql({
      query: updateCreditos,
      variables: {
        input: {
          id,
          creditosUsados: costo,
          tokensIngresados: inTokens,
          tokensRecibidos: outTokens,
        },
      },
    });

    console.log("PutRegistroCreditosByUserId:", { result });
    return result.data.updateCreditos;
  } catch (error) {
    console.error("error en la mutación PutRegistroCreditosByUserId", error);
    throw new Error("error en la mutación PutRegistroCreditosByUserId" + error);
  }
};

/**
 * Obtiene la lista de usuarios permitidos
 */
export const GetUsersWhiteList = async () => {
  try {
    let users: any = [];
    let nextToken = null;
    do {
      const response: any = await client.graphql({
        query: listWhitelistUsers,
        variables: { nextToken },
      });
      const result = response.data.listWhitelistUsers;
      users = users.concat(result.items);
      nextToken = result.nextToken;
    } while (nextToken);

    console.log("GetUsersWhiteList:", { users });
    return users;
  } catch (error) {
    console.error("error en la query GetUsersWhiteList", error);
  }
};

/**
 *
 * @param usuarioId
 * @param profileUserData
 * @returns
 */
export const PostUserProfile = async (
  usuarioId: string,
  profileUserData: any
) => {
  console.log(
    `PostUserProfile usuarioId=${usuarioId} proyectoObj=${JSON.stringify(
      profileUserData
    )}`
  );
  const { name, lastname, phoneNumber, cargo, RBD, colegio, pais, ciudad, especialidades } =
    profileUserData;

  // Validar que los campos indexados no estén vacíos
  const validateField = (field: any) => field && field.trim().length > 0;

  try {
    const result = await client.graphql({
      query: createPerfil,
      variables: {
        input: {
          usuarioId,
          cargo,
          ...(validateField(RBD) && { RBD }),
          ...(validateField(colegio) && { colegio }),
          pais,
          ciudad,
          nombre: name,
          apellido: lastname,
          tel: phoneNumber,
          especialidades: Array.isArray(especialidades) ? especialidades : [],
        },
      },
    });
    console.log("PostUserProfile", { result });
    return result;
  } catch (error) {
    console.error("error en la mutacion PostUserProfile", error);
  }
};

/**
 *
 * @param id
 * @param profileUserData
 * @returns
 */
export const PutUserProfile = async (id: string, profileUserData: any) => {
  console.log(`PutUserProfile profileId=${id} proyectoObj=${profileUserData}`);
  const { name, lastname, phoneNumber, cargo, RBD, colegio, pais, ciudad, especialidades } =
    profileUserData;
  const validateField = (field: any) => field && field.trim().length > 0;
  try {
    const result = await client.graphql({
      query: updatePerfil,
      variables: {
        input: {
          id,
          cargo,
          ...(validateField(RBD) && { RBD }),
          ...(validateField(colegio) && { colegio }),
          pais,
          ciudad,
          nombre: name,
          apellido: lastname,
          tel: phoneNumber,
          especialidades: Array.isArray(especialidades) ? especialidades : [],
        },
      },
    });
    console.log("Result PutUserProfile", { result });
    return result;
  } catch (error) {
    console.error("error en la mutacion PutUserProfile", error);
  }
};

/**
 *
 * @param userId
 * @param limit
 * @returns
 */
export const GetUserLoginLogByUserId = async (
  userId: string,
  limit: number
): Promise<iDataUserLogs[]> => {
  let allItems: iDataUserLogs[] = [];
  let nextToken: string | null = null;

  try {
    console.log(`GetUserLoginLogByUserId userId=${userId} limit=${limit}`);

    do {
      const result: any = await client.graphql({
        query: logsByUsuarioId,
        variables: {
          usuarioId: userId,
          filter: {
            action: {
              eq: "LOGIN_SUCCESSFUL",
            },
          },
          nextToken: nextToken, // Pasar el nextToken para obtener el siguiente lote de resultados
        },
      });

      // Manejo seguro de los items y nextToken
      const items = result?.data?.logsByUsuarioId?.items ?? [];
      allItems = allItems.concat(items);

      nextToken = result?.data?.logsByUsuarioId?.nextToken ?? null;
      console.log(`Fetched ${items.length} items, nextToken: ${nextToken}`);
    } while (nextToken);

    if (allItems.length === 0) {
      console.log("No se encontraron registros de LOGIN_SUCCESSFUL.");
      return [];
    }

    // Ordena los elementos por fecha de creación descendente
    allItems.sort(
      (a: iDataUserLogs, b: iDataUserLogs) =>
        new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
    );

    // Aplica el límite después de ordenar
    const limitedItems = allItems.slice(0, limit);

    console.log("GetUserLoginLogByUserId:", { items: limitedItems });
    return limitedItems;
  } catch (error: any) {
    console.error("Error en la query GetUserLoginLogByUserId", error);
    throw new Error(
      `Error en la query GetUserLoginLogByUserId: ${error.message}`
    );
  }
};

/**
 *
 * @param proyectoId
 * @param inputUserData
 * @param etapa
 * @returns
 */
export const PostProjectUserInput = async (
  proyectoId: string,
  inputUserData: string,
  etapa: number
) => {
  console.log(
    `PostProjectUserInput proyectoId=${proyectoId} input=${JSON.stringify(
      inputUserData
    )}, etapa=${etapa}`
  );
  try {
    const result = await client.graphql({
      query: createProjectUserInput,
      variables: {
        input: {
          proyectoId,
          etapa: Number(etapa),
          input: JSON.stringify(inputUserData),
        },
      },
    });
    console.log("PostProjectUserInput", { result });
    return result;
  } catch (error) {
    console.error("error en la mutacion PostProjectUserInput", error);
  }
};

/**
 *
 * @param resultadoId
 * @param data
 * @returns
 */
export const PutResultadoById = async (
  resultadoId: string,
  data: Record<string, any>
) => {
  try {
    const result = await client.graphql({
      query: updateResultado,
      variables: {
        input: {
          id: resultadoId,
          ...data,
        },
      },
    });
    console.log("PutResultadoById", { result });
    return result;
  } catch (error) {
    console.error("error en la mutacion PutResultadoById", error);
  }
};


export const updateProyectoById = async (
  proyectoId: string,
  dataToUpdate: Partial<{ isEliminated?: boolean; nombre?: string }>
) => {
  try {
    const proyectoActual = await GetProyectoById(proyectoId);    

    if (!proyectoActual) throw new Error("Proyecto no encontrado");

    // Mapeo del campo 'nombre' a 'name' para GraphQL
    const mappedData = {
      ...dataToUpdate,
      ...(dataToUpdate.nombre ? { name: dataToUpdate.nombre } : {}),
    };

    const updatedProyecto = { ...proyectoActual, ...mappedData };

    // Solo los campos válidos para el input
    const allowedFields = ["id", "name", "isEliminated"];

    // Filtramos para evitar errores en el input
    const filteredInput = Object.fromEntries(
      Object.entries(updatedProyecto).filter(([key]) =>
        allowedFields.includes(key)
      )
    );

    const result = await client.graphql({
      query: updateProyecto,
      variables: {
        input: filteredInput,
      },
    });

    console.log("Proyecto actualizado:", result);
    return result;
  } catch (error) {
    console.error("Error al actualizar proyecto:", error);
    throw error;
  }
};


export const startChatAgentSession = async (userId: string, proyectoId: string, resultadoId: string) => {
  const chatId = uuidv4();
  try {
    const response = await client.graphql({
      query: createChatAgentSession,
      variables: {
        input: {
          id: chatId,
          userId,
          modelName: "",
          modelId: "",
          proyectoId,
          resultadoId,
          totalTokens: 0,
          creditosDescontados: 0,
        },
      },
    });
    console.log("Chat agent session iniciada:", response);
    return response;
  } catch (error) {
    console.error("Error al iniciar sesión del agente de chat:", error);
    throw error;
  }
};

export const postControlError = async (userId: string, clientInfo:ClientInfo, servicio:string, error:Error, infoReact:React.ErrorInfo) => {
  try {
    const {browser, browserVersion, deviceType, os, osVersion, url, } = clientInfo;
    const sessionId = getOrCreateSessionId();
    const now = Math.floor(Date.now() / 1000);
    const threeMonthsSeconds = 60 * 60 * 24 * 90;

    const input = {      
      usuarioId: userId || null,
      sessionId,
      browser,
      browserVersion,
      os,
      osVersion,
      deviceType,
      url,
      servicio,
      mensaje: error.message,
      stackTrace: error.stack || "",
      info: typeof infoReact === "string" ? infoReact : JSON.stringify(infoReact || {}),
      expiresAt: now + threeMonthsSeconds
    };

    const response = await client.graphql({
      query: createControlError,
      variables: {input},
    });
    console.log("Control error registrado:", response);
    return response;
  } catch (error) {
    console.error("Error al registrar control error:", error);
    throw error;
  }
};

  // id: ID! @primaryKey  
  // timestamp: AWSDateTime!
  // browser: String
  // browserVersion: String
  // os: String
  // osVersion: String
  // servicio: String! @index(name: "byServicio")
  // mensaje: String!
  // stackTrace: String
  // usuarioId: ID! @index(name: "byUsuario")